import { computed, Injectable } from '@angular/core';
import { injectLocalStorage } from 'ngxtension/inject-local-storage';

interface TokenData {
  token: string;
  expiresAt?: number;
}

@Injectable({
  providedIn: 'root',
})
export class AuthTokenStorageService {
  readonly #storageKey = 'stxAuthToken';
  readonly #tokenData = injectLocalStorage<TokenData | null>(this.#storageKey);

  readonly token = computed(() => this.#tokenData()?.token ?? null);
  readonly hasActiveToken = computed(() => !!this.token());

  setToken(token: string, expiresAt?: number): void {
    this.#tokenData.set({ token, expiresAt });
  }

  clear(): void {
    this.#tokenData.set(null);
  }
}
